<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.EDIT_SOCIAL_LINKS' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="updateProduct()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

          <!-- ===== Row 1 ===== -->
          <div class="row">
            <!-- Link -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-medium">
                {{ 'MENU.DASHBOARD.Link' | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                placeholder="{{ 'MENU.DASHBOARD.Link' | translate }}"
                [(ngModel)]="product.link"
                name="link"
                required
              />
            </div>
<!-- Platform -->
<div class="col-md-6 mb-3">
  <label class="form-label fw-medium">
    {{ 'MENU.DASHBOARD.Platform' | translate }}
  </label>

  <select
    class="form-control"
    [(ngModel)]="product.platform"
    name="platform"
    required
  >
    <option value="" disabled>
      {{ 'MENU.DASHBOARD.Select_Platform' | translate }}
    </option>

    <option *ngFor="let p of platforms" [value]="p">
      {{ p | titlecase }}
    </option>
  </select>
</div>

          </div>

          <!-- ===== Submit Button ===== -->
          <div class="d-flex justify-content-end mt-4">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Save_Changes' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>
</div>
